/* eslint-disable camelcase */
import axios from 'axios';
import { useMutation } from 'react-query';
import { useReportError } from '~/hooks/useReportError';
import { toast } from 'react-toastify';
function updateRequest(params) {
    const { patientId, email, phone, dob, primaryInsurance, secondaryInsurance, mrn, followUp, diagnosis, secondaryDiagnosis, waitingUntil, nextAppointment, lastAppointment } = params;
    const fd = new FormData();
    fd.append('patient_id', patientId);
    if (email) {
        fd.append('patient_email', email);
    }
    if (phone) {
        fd.append('phone', phone);
    }
    if (dob) {
        fd.append('dob', dob);
    }
    if (primaryInsurance) {
        fd.append('primary_insurance', primaryInsurance);
    }
    if (secondaryInsurance) {
        fd.append('secondary_insurance', secondaryInsurance);
    }
    if (mrn) {
        fd.append('mrn', mrn);
    }
    if (followUp) {
        fd.append('follow_up', followUp);
    }
    if (diagnosis) {
        fd.append('diagnosis_code', diagnosis);
    }
    if (secondaryDiagnosis) {
        fd.append('secondary_diagnosis_code', secondaryDiagnosis);
    }
    if (waitingUntil) {
        fd.append('waiting_until', waitingUntil);
    }
    if (nextAppointment) {
        fd.append('next_appointment', nextAppointment);
    }
    if (lastAppointment) {
        fd.append('last_appointment', lastAppointment);
    }
    return axios.post('/api/patient/storeChanges', fd);
}
export function usePatientMutation() {
    const reportError = useReportError();
    return useMutation(updateRequest, {
        onSuccess: () => {
            //toast.success('Changes saved successfully.');
        },
        onError: (err) => {
            reportError('Error saving patient', err);
            toast.error('We could’t save your changes. Please try again.');
        },
    });
}
